import React, { useEffect, useState } from 'react';
import { currentBrand } from "@pb/utils/brandConfig";
import { default as getCurrentBreakpoint } from "@pb/utils/getCurrentBreakpoint";
import { default as getLabelFromStorage } from "@pb/utils/labels/getLabelFromStorage";
import { getLocale } from "@pb/utils/locale";
import { isArketBrand } from "@pb/utils/brandConfig";
import { isCosBrand } from "@pb/utils/brandConfig";
import { parseLocale } from "@pb/utils/locale";
import { default as useBreakpoint } from "@pb/utils/reactHooks/useBreakpoint";
import ProductTile from "../../compositions/ProductTile";
import { trackingQSP } from "../../compositions/ProductTileComposition/components/ProductDetails/QuickShopModal/util/tracking";
import IntersectionVisible from "../../helpers/IntersectionVisible";
import Carousel from "../../ui/Carousel";
import CarouselProps from "../../ui/Carousel/types";
import brandStyles from './BrandMatchingSet.module.scss';
import { CAROUSEL_CONFIG } from './constants';
import trackProductEvent from './helpers/trackProductEvent';
import styles from './MatchingSet.module.scss';
import { TrackingEvent } from './types';
const MatchingSet = ({ matchingSet, title }) => {
    const [carouselIsShown, setCarouselIsShown] = useState(false);
    const praLocale = parseLocale(getLocale()).country || '';
    const [breakpoint, setBreakpoint] = useState();
    const [trackedProducts, setTrackedProducts] = useState([]);
    const [hasQSPLoaded, setQSPLoaded] = useState(false);
    const [isQSPOpen, setQSPOpen] = useState(false);
    const handleQSPOpen = () => {
        setQSPOpen(true);
        trackingQSP('quickshop', 'quickshop', 'button.quickshop');
    };
    const handleQSPClose = () => {
        setQSPOpen(false);
    };
    const handleQSPLoaded = () => {
        setQSPLoaded(true);
    };
    const breakpointState = useBreakpoint();
    const { numOfItemsPerSlide } = CAROUSEL_CONFIG[`${process.env.BRAND_PREFIX}`] || Object.values(CAROUSEL_CONFIG)[0];
    const numOfVisibleSlides = breakpoint ? numOfItemsPerSlide[breakpoint] : 0;
    const labels = {
        next: isCosBrand ? getLabelFromStorage('matchingSet.next') : '',
        prev: isCosBrand ? getLabelFromStorage('matchingSet.prev') : '',
        title: getLabelFromStorage('matchingSet.title'),
        matchingSetTag: isCosBrand ? getLabelFromStorage('matchingSet.tag') : '',
        quickBuyLabel: getLabelFromStorage('productTile.quickShop.button'),
    };
    const trackViewedProducts = (eventType, currentSlide) => {
        const viewedProducts = matchingSet.articles.slice(currentSlide, currentSlide + numOfVisibleSlides);
        const productsToTrack = viewedProducts.filter((product) => !trackedProducts.includes(product));
        setTrackedProducts(trackedProducts.concat(productsToTrack));
        if (productsToTrack.length) {
            trackProductEvent(eventType, productsToTrack, currentSlide, labels.title);
        }
    };
    const carouselProps = {
        labels,
        title: title || labels.title,
        titleSize: isArketBrand ? 'medium' : 'small',
        titleClassName: brandStyles[`${currentBrand}CarouselHeading`],
        numOfItemsPerSlide,
        isArrowAlignedWithNoPadding: false,
        isInfinite: process.env.IS_PRA_WITH_INFINITY_SCROLL === 'enabled',
        showDotsWithArrows: process.env.IS_PRA_DOTS_WITH_ARROWS === 'enabled',
        arrowsToTopRight: process.env.IS_PRA_WITH_ARROWS_TO_TOP_RIGHT === 'enabled',
        isTitleCenterAligned: process.env.IS_PRA_TITLE_CENTRE_ALIGN_DISABLED !== 'enabled',
        isDotsOnTop: process.env.IS_PRA_DOTS_ABOVE_CAROUSEL === 'enabled',
        shouldRenderEmptySlides: false,
        noPadding: process.env.IS_PRA_CAROUSEL_PADDING_DISABLED === 'enabled',
        bleedOut: process.env.IS_PRA_CAROUSEL_BLEEDOUT_DISABLED === 'enabled',
        arrowIconType: process.env.IS_PRA_CONTROL_WITH_CHEVRON_DISABLED === 'enabled'
            ? 'chevrons-left-right'
            : 'arrows-left-right',
        arrowBackground: process.env.IS_PRA_ARROW_WITH_BACKGROUND_DISABLED === 'enabled' ? 'opaque' : 'default',
        arrowPosition: process.env.IS_PRA_ARROW_ALIGNED_TO_IMAGE === 'enabled' ? 'alignedToImage' : 'default',
        arrowBackgroundSize: process.env.IS_PRA_ARROW_WITH_SMALL_BACKGROUND === 'enabled' ? 'small' : 'default',
        onlyArrows: process.env.IS_PRA_ONLY_ARROWS === 'enabled',
        onlyArrowsDesktop: process.env.IS_PRA_ONLY_ARROWS_DESKTOP === 'enabled',
        carouselHeadingClassName: brandStyles[`${currentBrand}CarouselHeadingContainer`],
        onAfterChange: (currentSlide) => {
            trackViewedProducts(TrackingEvent.IMPRESSION, currentSlide);
        },
    };
    useEffect(() => {
        if (matchingSet.articles.length && carouselIsShown) {
            trackViewedProducts(TrackingEvent.IMPRESSION, 0);
        }
    }, [carouselIsShown, matchingSet]);
    useEffect(() => {
        if (breakpointState === getCurrentBreakpoint()) {
            setBreakpoint(breakpointState);
        }
    }, [breakpointState]);
    const generateProductTile = (key, article, image) => {
        var _a, _b, _c, _d, _e;
        return (React.createElement(ProductTile, { key: key, showRedPriceFirst: false, redPrice: (_b = (_a = article === null || article === void 0 ? void 0 : article.redPrice) === null || _a === void 0 ? void 0 : _a.formattedPrice) !== null && _b !== void 0 ? _b : undefined, regularPrice: (_d = (_c = article === null || article === void 0 ? void 0 : article.whitePrice) === null || _c === void 0 ? void 0 : _c.formattedPrice) !== null && _d !== void 0 ? _d : undefined, priorPriceLabel: !isCosBrand ? article === null || article === void 0 ? void 0 : article.priorPriceLabel : undefined, priorPrice: !isCosBrand ? (_e = article === null || article === void 0 ? void 0 : article.priorPrice) === null || _e === void 0 ? void 0 : _e.formattedPrice : undefined, hasPriceMarker: !isArketBrand && (article === null || article === void 0 ? void 0 : article.hasPriceMarker), comparativePrice: article === null || article === void 0 ? void 0 : article.comparativePrice, markers: !isArketBrand ? article.markers : undefined, titleClassName: brandStyles[`${currentBrand}ProductTitle`], priceClassName: brandStyles[`${currentBrand}ProductPrice`], regularPriceClassName: brandStyles[`${currentBrand}ProductPrice`], redPriceClassName: brandStyles[`${currentBrand}ProductPrice`], markerWrapperClassname: brandStyles[`${currentBrand}ProductMarker`], productMarkerClassName: brandStyles[`${currentBrand}ProductMarker`], shouldUnderlineTitleOnHover: false, className: styles.productTile, useModelAsDefault: false, shouldLazyLoad: false, imageProductSrc: image, articleCode: article.code, title: article.name, pdpUrl: !isArketBrand ? article.articleUrl : undefined, category: article.mainCategory.code, imageProductAlt: article.name, isNewProduct: article.new, showEnergyButton: false, brandName: article.brandName, isOutOfStock: !article.inStock, showFavoriteButton: false, hasQSPLoaded: hasQSPLoaded, isQSPOpen: isQSPOpen, onHandleQSPOpen: handleQSPOpen, onHandleQSPClose: handleQSPClose, onHandleQSPLoaded: handleQSPLoaded, isQuickShopButtonVisible: !isArketBrand, isProductTileDetailsCentreAligned: process.env.IS_PRODUCT_TILE_DETAILS_CENTRE_ALIGNED === 'enabled', isMarkersAboveProductName: false, matchingSetLabel: labels.matchingSetTag, quickBuyLink: article.quickBuyLink, quickBuyLabel: labels.quickBuyLabel, praLocale: praLocale, linkClickCallback: () => {
                trackProductEvent(TrackingEvent.CLICK, [article], 0, labels.title);
                if (isArketBrand) {
                    handleQSPOpen();
                }
            } }));
    };
    return (React.createElement(IntersectionVisible, { onShow: () => setCarouselIsShown(true), onHide: () => setCarouselIsShown(false), active: true, options: { threshold: 0.1 }, "data-testid": "matching-set" },
        React.createElement(Carousel, Object.assign({}, carouselProps), matchingSet.articles.flatMap((article) => {
            var _a;
            const tiles = [generateProductTile(article.code, article, article.productImage.url)];
            if (matchingSet.articles.length === 1 && ((_a = article.modelImage) === null || _a === void 0 ? void 0 : _a.url)) {
                tiles.push(generateProductTile(`${article.code}-model`, article, article.modelImage.url));
            }
            return tiles;
        }))));
};
export default MatchingSet;
//# sourceMappingURL=MatchingSet.js.map